import * as $ from 'jquery';

export interface JekyllResource {
    title: {
        headline: string;
        emphasis: string;
    },
    tags?: string[];
    description: string;
    synopsis: string;
    url?: string;
}

export interface CustomRender {
    selector: string;
    render: (res: JekyllResource, el: Element) => void;
}

const cache: {[key: string]: JekyllResource[] |  undefined }  = {};

const getResourceList = async (path:  string, versionHash: string): Promise<JekyllResource[]> => {

    if (cache[path] === undefined) {
        const data = await $.get(`${path}?${versionHash}`);
        cache[path] = data.items;
    }
    return cache[path] as JekyllResource[];
};

export const getPosts = async (versionHash: string): Promise<JekyllResource[]> =>
    getResourceList('/api/posts.json', versionHash);

export const getMiniExplorations = async (versionHash: string): Promise<JekyllResource[]> =>
    getResourceList('/api/mini-explorations.json', versionHash);

export const getOfferings = async (versionHash: string): Promise<JekyllResource[]> =>
    getResourceList('/api/offerings.json', versionHash);

export const getFilterCategories = async (versionHash: string): Promise<JekyllResource[]> =>
    getResourceList('/api/filter.json', versionHash);

const renderResource = (resource: JekyllResource, template: HTMLElement, customRenders: CustomRender[]): HTMLElement => {
    const templateClone = document.importNode(template, true);
    templateClone.querySelectorAll('.resource__headline').forEach(el => el.textContent = resource.title.headline);
    templateClone.querySelectorAll('.resource__emphasis').forEach(el => el.textContent = resource.title.emphasis);
    templateClone.querySelectorAll('.resource__description').forEach(el => el.textContent = resource.description);
    templateClone.querySelectorAll('.resource__synopsis').forEach(el => el.textContent = resource.synopsis);
    templateClone.querySelectorAll('.resource__href').forEach((el: HTMLAnchorElement | HTMLSourceElement) => {
        if (el instanceof HTMLAnchorElement) {
            el.href = resource.url ?? '#';
        } else {
            el.src = resource.url ?? '#';
        }
    });
    customRenders.forEach((customRender) => templateClone.querySelectorAll(customRender.selector).forEach(el => customRender.render(resource, el)));
    return templateClone;
};

const renderResources = (
    resources: JekyllResource[],
    templateSelector: string,
    customRenders?: CustomRender[]
): HTMLElement[] => {
    const template = $(templateSelector).prop('content');
    return resources.map((resource) => renderResource(resource, template, customRenders ?? []));
};

export const renderJekyllResourcesAppend = (
    resources: JekyllResource[],
    templateSelector: string,
    containerSelector: string,
    customRenders?: CustomRender[]
): void => {
    const parent = $(containerSelector);
    parent.append(renderResources(resources, templateSelector, customRenders));
};

export const renderJekyllResourcesReplace = (
    resources: JekyllResource[],
    templateSelector: string,
    containerSelector: string,
    customRenders?: CustomRender[]
): void => {
    const parent = $(containerSelector);
    parent.empty();
    parent.append(renderResources(resources, templateSelector, customRenders));
};